import React, {memo} from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const textType = (wrapType)=>{
    let type = 'text';
    switch(wrapType){
        case 'number':type = 'text';break;
        default:type = wrapType;
    }
    return type;
}
const TextFieldWrapper = memo(({
    wrapType = "text",
    validationOptions = {},
    onTogglePassword,
    showPassword,
    onChange,
    ...restOpts
})=>{
    const props = {...restOpts}
    if(wrapType == 'password'){
        props.slotProps = {...props.slotProps,input:{
            ...props.slotProps?.input,
            endAdornment: <InputAdornment position="end"><IconButton edge="end" onClick={onTogglePassword}>{showPassword?<VisibilityOff />:<Visibility />}</IconButton></InputAdornment>
        }}
    }
    const validateNum = (value)=>{
        let v = /^(0|[1-9]\d*)$/.test(value) || value == '';
        v && validationOptions.maxLength && (v = (value+'').length<= validationOptions.maxLength)
        v && validationOptions.max && (v= value <= validationOptions.max)
        return v;
    }
    const changeHandler = (e)=>{
        switch(wrapType){
            case 'number':validateNum((e.target.value || '')) && onChange && onChange(e);break;
            default:onChange && onChange(e);
        }
    }
    return <TextField {...props} type={showPassword?'text':textType(wrapType)} onChange={changeHandler}/>
});

export default TextFieldWrapper;